import React from 'react';
import { Typography, Box } from '@mui/material';
import { GlassInfoCard, GlassWarningCard } from './ui/GlassComponents';

const EntityCreationWarning = ({ entityType = 'entity', additionalWarning = null }) => {
  return (
    <>
      {additionalWarning && (
        <GlassInfoCard severity="info">
          {additionalWarning}
        </GlassInfoCard>
      )}
      <GlassWarningCard
        severity="warning"
        title="Before You Continue: Creating an Entity is Permanent"
      >
        <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255, 255, 255, 0.95)' }}>
          Creating a {entityType} is a significant and lasting action in Statecraft. These entities are not temporary or disposable:
        </Typography>
        <Box component="ul" sx={{ mt: 1, mb: 1, pl: 2, color: 'rgba(255, 255, 255, 0.95)' }}>
          <li style={{ marginBottom: '8px' }}>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.95)' }}>
              <strong style={{ color: 'rgba(255, 255, 255, 1)' }}>🛑 You cannot delete it yourself.</strong> Only an administrator can remove a nation or bank (and even then, it's rare and only under exceptional circumstances.)
            </Typography>
          </li>
          <li style={{ marginBottom: '8px' }}>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.95)' }}>
              <strong style={{ color: 'rgba(255, 255, 255, 1)' }}>📜 It becomes part of the canon.</strong> Once created, your {entityType} is permanently recorded in the world. It exists, with or without you.
            </Typography>
          </li>
          <li style={{ marginBottom: '8px' }}>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.95)' }}>
              <strong style={{ color: 'rgba(255, 255, 255, 1)' }}>💰 All debts are permanent.</strong> Any financial or contractual obligations your entity accrues are real and persist in the game's economy. There are no do-overs.
            </Typography>
          </li>
        </Box>
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'rgba(255, 255, 255, 1)' }}>
          Please be sure you are ready and able to maintain this entity over time.
        </Typography>
      </GlassWarningCard>
    </>
  );
};

export default EntityCreationWarning; 